import React from 'react';
import { Menu } from 'antd';
import { useSelector } from 'react-redux';
import { NavLink, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
import { PERMISSIONS } from '../config/permissions';
import { toKebabCase } from '../utility/utility';

const MenuItems = ({ darkMode, toggleCollapsed, topMenu }) => {
  const permissions = useSelector((state) => state.auth.user.permissions);
  const { path } = useRouteMatch();
  const pathName = window.location.pathname;
  const mainPathSplit = pathName.split('/');
  const [openKeys, setOpenKeys] = React.useState(!topMenu ? [`${mainPathSplit[1] !== '' ? mainPathSplit[1] : 'dashboard'}`] : []);

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 0) setOpenKeys([]);
  };

  const selectedKeys = () => {
    const keys = [];
    switch (mainPathSplit.length) {
      case 1:
        if (mainPathSplit[0] === '') {
          keys[0] = 'dashboard-general';
        } else {
          [keys[0]] = mainPathSplit;
        }
        break;

      case 2:
        if (mainPathSplit[1] === 'dashboard') {
          keys[0] = 'dashboard-general';
        } else {
          [, keys[0]] = mainPathSplit;
        }
        break;

      case 3:
        if (['user'].includes(mainPathSplit[1])) {
          [, keys[0]] = mainPathSplit;
        } else {
          keys[0] = `${mainPathSplit[1]}-${mainPathSplit[2]}`;
        }
        break;

      case 4:
        if (['user'].includes(mainPathSplit[1])) {
          [, keys[0]] = mainPathSplit;
        } else {
          keys[0] = `${mainPathSplit[1]}-${mainPathSplit[2]}`;
        }
        break;

      case 5:
        keys[0] = `${mainPathSplit[1]}-${mainPathSplit[2]}`;
        break;

      default:
        [, keys[0]] = mainPathSplit;
        break;
    }
    return keys;
  };

  const hasPermission = (perm) => permissions.includes(perm);

  const buildMenuItem = (label, key, route, iconName = null) => ({
    label: (
      <NavLink onClick={toggleCollapsed} to={`${path}${route}`}>
        {label}
      </NavLink>
    ),
    key,
    icon: !topMenu && iconName && (
      <NavLink className="menuItem-iocn" to={`${path}${route}`}>
        <FeatherIcon icon={iconName} />
      </NavLink>
    ),
  });

  const buildMenuGroup = (label, key, children, iconName = null) => {
    const filtered = children.filter(Boolean);
    if (filtered.length === 0) return null;

    return {
      label,
      key,
      children: filtered,
      icon: !topMenu && iconName && (
        <NavLink className="menuItem-iocn btnMenu-icon" to="#">
          <FeatherIcon icon={iconName} />
        </NavLink>
      ),
    };
  };

  const generateSubMenu = (prefix, subPermissions) =>
    Object.entries(subPermissions).map(([key, perm]) =>
      hasPermission(perm.view.value) ? buildMenuItem(perm.label, `${prefix}-${toKebabCase(key)}`, `${prefix}/${toKebabCase(key)}`) : null,
    );

  const items = [
    {
      label: 'Dashboard',
      key: 'dashboard',
      children: [
        buildMenuItem('General', 'dashboard-general', 'dashboard'),
        hasPermission(PERMISSIONS.dashboard.maintenance.value) && buildMenuItem('Workshop', 'dashboard-workshop', 'dashboard/workshop'),
        hasPermission(PERMISSIONS.dashboard.warehouse.value) && buildMenuItem('Warehouse', 'dashboard-warehouse', 'dashboard/warehouse'),
      ].filter(Boolean),
      icon: !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}dashboard`}>
          <FeatherIcon icon="home" />
        </NavLink>
      ),
    },
    buildMenuGroup(PERMISSIONS.master.label, 'master', generateSubMenu('master', PERMISSIONS.master.sub), 'grid'),
    buildMenuGroup(PERMISSIONS.maintenance.label, 'maintenance', generateSubMenu('maintenance', PERMISSIONS.maintenance.sub), 'alert-circle'),
    buildMenuGroup(PERMISSIONS.license.label, 'license', generateSubMenu('license', PERMISSIONS.license.sub), 'file'),
    buildMenuGroup(PERMISSIONS.partRequisition.label, 'part-requisition', generateSubMenu('part-requisition', PERMISSIONS.partRequisition.sub), 'box'),
    buildMenuGroup(PERMISSIONS.warehouseInventory.label, 'warehouse-inventory', generateSubMenu('warehouse-inventory', PERMISSIONS.warehouseInventory.sub), 'grid'),
    buildMenuGroup(PERMISSIONS.report.label, 'report', generateSubMenu('report', PERMISSIONS.report.sub), 'file-text'),
    buildMenuGroup(PERMISSIONS.users.label, 'users', generateSubMenu('users', PERMISSIONS.users.sub), 'users'),
  ].filter(Boolean);

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [`${mainPathSplit.length === 1 ? (mainPathSplit[0] === '' ? 'dashboard' : mainPathSplit[0]) : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]}`]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 1 ? mainPathSplit[0] : 'dashboard'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
      selectedKeys={selectedKeys()}
      items={items}
    />
  );
};

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
